export interface IPurchaserPortalKey {
  id: number;
  portalKeyName: string;
  portalKey: string;
  appPurchaserId: number;
  purchaserKey: string;
}

export class PurchaserPortalKey {
  private readonly _id: number;
  private readonly _portalKeyName: string;
  private readonly _portalKey: string;
  private readonly _appPurchaserId: number;
  private readonly _purchaserKey: string;

  constructor(props: IPurchaserPortalKey) {
    this._id = props.id;
    this._portalKeyName = props.portalKeyName;
    this._portalKey = props.portalKey;
    this._appPurchaserId = props.appPurchaserId;
    this._purchaserKey = props.purchaserKey;
  }

  get id(): number {
    return this._id;
  }
  get portalKeyName(): string {
    return this._portalKeyName;
  }
  get portalKey(): string {
    return this._portalKey;
  }
  get appPurchaserId(): number {
    return this._appPurchaserId;
  }
  get purchaserKey(): string {
    return this._purchaserKey;
  }

  static from(props: IPurchaserPortalKey): PurchaserPortalKey {
    return new PurchaserPortalKey(props);
  }

  static toJSON(entity: PurchaserPortalKey): IPurchaserPortalKey {
    return {
      id: entity.id,
      portalKeyName: entity.portalKeyName,
      portalKey: entity.portalKey,
      appPurchaserId: entity.appPurchaserId,
      purchaserKey: entity.purchaserKey,
    };
  }
}
